import React, { useState, useEffect } from 'react';
import * as S from '../SrpCard/srp-card-ui.styles';
import Flight from '../../../icons/Flight';
import BaggageDetails from '../../Common/BaggageCancellationRules/baggage-details';
import CancellationDetails from '../../Common/BaggageCancellationRules/cancellation-policy';
import CancellationAndReschedulePenalty from '../../Common/BaggageCancellationRules/cancellation-and-reschedule-policy/cancellation-and-reschedule-penalty';
import FareDetails from '../../Common/BaggageCancellationRules/bagCancelRules';
import CancellationRescheduleTabView from '../../Common/BaggageCancellationRules/cancellation-and-reschedule-policy/cancellation-reschedule-tab-view';
import { CANCELLATION_ID } from '@stencil/flights-constants/src/text';
import Amenities from './amenities';

const msToHMS = ms => {
  const minutes = Math.floor((ms / 1000 / 60) % 60);
  const hours = Math.floor((ms / 1000 / 3600) % 24);

  return `${hours}h ${minutes > 9 ? minutes : '0' + minutes}m`;
};

export function FlightDetailRoute({
  flight,
  departure,
  arrival,
  nextFlight,
  isDomesticRoundTrip,
  loadingAmenties,
  amenitiesData,
  handleTracking
}) {
  const {
    carrier,
    flightNumber,
    depCode,
    depTime,
    depDate,
    arrCode,
    arrTime,
    arrDate,
    duration,
    aircraft_type
  } = flight;

  let layoverText = null;
  let layoverDuration = null;

  const arrivalDate = new Date(arrDate.dateObj);

  arrivalDate.setHours(arrTime.split(':')[0]);
  arrivalDate.setMinutes(arrTime.split(':')[1]);

  const flightNumberDisplay = flightNumber.slice(0, 2) + ' - ' + flightNumber.slice(2);

  if (nextFlight) {
    const { depTime: nextFltDepTime, depDate: nextFltDepDate } = nextFlight;
    const nextFltDepartureDate = new Date(nextFltDepDate.dateObj);
    nextFltDepartureDate.setHours(nextFltDepTime.split(':')[0]);
    nextFltDepartureDate.setMinutes(nextFltDepTime.split(':')[1]);

    layoverText = nextFlight.depText;
    layoverDuration = msToHMS(nextFltDepartureDate - arrivalDate);
  }

  return (
    <>
      <S.FltDetailCont className="width100 flexCol">
        <div className="dF justifyBetween padL20 padR20">
          <div className="fGS0 width100 dF">
            <div className="widMd13 flexCol alignItemsStart">
              <S.CarrierLogo
                src={`https://imgak.goibibo.com/flights-gi-assets/images/v2/app-img/${carrier.carrierCode}.png`}
                alt="flights"
              />
              <span className="greyCnt padT5" name="SRP_Details_Flightcarriername">
                {carrier.carrierName}
              </span>
              <span className="db greyCnt" name="SRP_Details_FlightNo">
                {flightNumberDisplay}
              </span>
              <div
                className="db greyCnt marginT5"
                dangerouslySetInnerHTML={{ __html: aircraft_type }}
              ></div>
              {(carrier.operatingCarrierName && (
                <span className="db greyCnt">Operated by {carrier.operatingCarrierName}</span>
              )) ||
                null}
            </div>
            <div className="widMd31 flexCol txtRight padR10 padL0">
              <span className="font16 db padT5 padB5">
                <span className="f500 padR5" name="SRP_Details_Flightdepcode">
                  {depCode}
                </span>
                <span className="greyCnt" name="SRP_Details_Flightdeptime">
                  {depTime}
                </span>
              </span>
              <span className="flexCol greyCnt lh1-2">
                <span name="SRP_Details_Flightdep_airportname">{departure.n},</span>
                <span name="SRP_Details_Flightdep_countryname">{departure.c}</span>
              </span>
            </div>

            <div
              className={`col-md-3 flexCol txtCenter padT20 ${
                isDomesticRoundTrip ? '' : 'padLR20'
              }`}
            >
              <span className="dF justifyBetween alignItemsCenter backgroundLn">
                <i className="oval-2 fl"></i>
                <span className="padL10 padR10 whiteBg f500" name="SRP_Details_Flightduration">
                  {duration}
                </span>
                <Flight width="2rem" height="2rem" />
              </span>
              {/* <span className="greyCnt padT5 txtCap">Flight Duration</span> */}
            </div>

            <div className="widMd31 flexCol padR0 padL10">
              <span className="font16 db padT5 padB5">
                <span className="f500 padR5" name="SRP_Details_Flightarrcode">
                  {arrCode}
                </span>
                <span className="greyCnt" name="SRP_Details_Flightarrtime">
                  {arrTime}
                </span>
              </span>
              <span className="flexCol greyCnt lh1-2">
                <span name="SRP_Details_Flightarr_airportname">{arrival.n}</span>
                <span name="SRP_Details_Flightarr_countryname">{arrival.c}</span>
              </span>
            </div>
          </div>
        </div>
        <Amenities
          loadingAmenties={loadingAmenties}
          amenitiesData={amenitiesData}
          handleTracking={handleTracking}
        />
      </S.FltDetailCont>
      {layoverDuration ? (
        <S.LayoverWrap className="dF alignItemsCenter justifyCenter">
          <span className="flex1 txtCenter greyCnt">
            <span className="f500">Layover in {layoverText}</span> {layoverDuration}
          </span>
        </S.LayoverWrap>
      ) : null}
    </>
  );
}

const ExpandedDetails = ({
  isRoundTrip,
  selectedTab,
  flightItem,
  airports,
  commonRulesData,
  refundability,
  isDomesticRoundTrip = false,
  getFlightAmenitiesData,
  handleTracking,
  logCancellationAndRescheduleDetails
}) => {
  const [showPoliciesOverlay, setShowPoliciesOverlay] = useState(CANCELLATION_ID);

  switch (selectedTab) {
    case 0:
      return (
        <>
          <FlightDetail
            isRoundTrip={isRoundTrip}
            flightItem={flightItem}
            airports={airports}
            getFlightAmenitiesData={getFlightAmenitiesData}
            handleTracking={handleTracking}
            isDomesticRoundTrip={isDomesticRoundTrip}
          />
          {flightItem.returnFlight ? (
            <FlightDetail
              isRoundTrip={isRoundTrip}
              fareKey={flightItem.fareKey}
              flightItem={flightItem.returnFlight}
              airports={airports}
              getFlightAmenitiesData={getFlightAmenitiesData}
              handleTracking={handleTracking}
              isDomesticRoundTrip={isDomesticRoundTrip}
            />
          ) : null}
        </>
      );
    case 1:
      return <FareDetails flightItem={flightItem} cardId={flightItem.id || ''} />;
    case 2:
      return (
        <BaggageDetails
          error={commonRulesData?.ed || ''}
          baggageData={commonRulesData && commonRulesData.baggage_data}
          meta={commonRulesData?.meta || null}
          cardId={flightItem.id || ''}
        />
      );
    case 3:
      if (isDomesticRoundTrip) {
        return (
          <CancellationRescheduleTabView
            error={commonRulesData?.ed || ''}
            activePolicySection={showPoliciesOverlay}
            setShowPoliciesOverlay={setShowPoliciesOverlay}
            fareRulesPolicies={commonRulesData?.fare_rules?.tabs}
            logCancellationAndRescheduleDetails={logCancellationAndRescheduleDetails}
            cardId={flightItem.id || ''}
            showNote={false}
          />
        );
      }
      return (
        <CancellationAndReschedulePenalty
          error={commonRulesData?.ed || ''}
          fareRulesData={commonRulesData?.fare_rules}
          fareRulesSectorsOrder={commonRulesData?.meta?.po}
          logCancellationAndRescheduleDetails={logCancellationAndRescheduleDetails}
          cardId={flightItem.id || ''}
          isSRP={true}
          showHeader={false}
          showLoader={true}
        />
      );
    // return (
    //   <CancellationDetails
    //     error={commonRulesData?.ed || ''}
    //     cancellationData={commonRulesData && commonRulesData.minirules_data}
    //     showDetails={true}
    //     isDomesticRoundTrip={isDomesticRoundTrip}
    //     isCollapsable={false}
    //     cardId={flightItem.id || ''}
    //   />
    // );
    default:
      return <div></div>;
  }
};

export function FlightDetail({
  flightItem,
  airports,
  getFlightAmenitiesData,
  handleTracking,
  isDomesticRoundTrip,
  fareKey = '',
  isRoundTrip = false
}) {
  const [loadingAmenties, setLoadingAmenties] = useState(false);
  const [amenitiesData, setAmenitiesData] = useState({});
  const airportDict = {};

  useEffect(() => {
    if (!isRoundTrip && getFlightAmenitiesData) {
      setLoadingAmenties(true);
      getFlightAmenitiesData(fareKey || flightItem.fareKey, (err, response) => {
        if (response?.amenities_data) {
          setAmenitiesData(response?.amenities_data);
        }
        setLoadingAmenties(false);
      });
    }
  }, []);

  airports.forEach(a => {
    airportDict[a.i] = a;
  });

  return (
    <S.FltDetailContWrp className="width100 flexCol">
      {flightItem.flightArr.map((flt, i) => (
        <FlightDetailRoute
          flight={flt}
          departure={airportDict[flt.depCode]}
          arrival={airportDict[flt.arrCode]}
          nextFlight={i < flightItem.flightArr.length ? flightItem.flightArr[i + 1] : null}
          key={flightItem.id + '_info_' + i}
          isDomesticRoundTrip={isDomesticRoundTrip}
          amenitiesData={amenitiesData[flt.lookupKey] || {}}
          loadingAmenties={loadingAmenties}
          handleTracking={handleTracking}
        />
      ))}
    </S.FltDetailContWrp>
  );
}

const FlightInfo = ({
  flightItem,
  airports,
  commonRulesData,
  refundability = false,
  callCommonRulesAPI,
  logPDT,
  pushGAEvents,
  pushAnalyticsEvents,
  typeOfTravel,
  isDomesticRoundTrip = false,
  getFlightAmenitiesData,
  handleTracking,
  isRoundTrip,
  logCancellationAndRescheduleDetails = () => {}
}) => {
  const [selectedTab, setSelectedTab] = useState(0);

  useEffect(() => {
    if (logPDT) {
      const pdtTabNames = [
        'flight_details_clicked',
        'fare_details',
        'baggage_rules',
        'cancellation_rules'
      ];
      logPDT({ action_name: pdtTabNames[selectedTab] });
    }
    if (pushGAEvents) {
      const gaTabNames = [
        'flightInformation',
        'fareDetails',
        'baggageInformation',
        'cancellationRules'
      ];
      pushGAEvents(
        'fltHpyViewDetails_' + typeOfTravel.toLowerCase(),
        gaTabNames[selectedTab],
        '',
        ''
      );
    }
    if (pushAnalyticsEvents) {
      const analyticsTabNames = [
        'flightInformation',
        'fareDetailsClicked',
        'baggageRulesClicked',
        'cancellationRulesClicked'
      ];
      pushAnalyticsEvents({ pageType: 'SRP', eventName: analyticsTabNames[selectedTab] });
    }
  }, [selectedTab]);

  return (
    <S.FlightDetailsWrap>
      <S.FltDetailCnt>
        <S.FltHpyDtlMenu className="greyCnt alignItemsCenter justifyBetween dF f600 txtUpper">
          {' '}
          <span
            className={'curPointFlt' + (selectedTab === 0 ? ' switchAct' : '')}
            name="SRP_Details_FlightInfo"
            onClick={() => setSelectedTab(0)}
          >
            Flight Information
          </span>
          <span
            className={'curPointFlt' + (selectedTab === 1 ? ' switchAct' : '')}
            name="SRP_Details_FareInfo"
            onClick={() => setSelectedTab(1)}
          >
            Fare Details
          </span>
          <span
            className={'curPointFlt' + (selectedTab === 2 ? ' switchAct' : '')}
            name="SRP_Details_BaggageInfo"
            onClick={() => {
              setSelectedTab(2);
              if (!commonRulesData) callCommonRulesAPI();
            }}
          >
            Baggage Rules
          </span>
          <span
            className={'curPointFlt' + (selectedTab === 3 ? ' switchAct' : '')}
            name="SRP_Details_CancellationInfo"
            onClick={() => {
              setSelectedTab(3);
              if (!commonRulesData) callCommonRulesAPI();
            }}
          >
            Cancellation Rules
          </span>
        </S.FltHpyDtlMenu>
        <ExpandedDetails
          isRoundTrip={isRoundTrip}
          selectedTab={selectedTab}
          flightItem={flightItem}
          refundability={refundability}
          airports={airports}
          commonRulesData={commonRulesData}
          isDomesticRoundTrip={isDomesticRoundTrip}
          getFlightAmenitiesData={getFlightAmenitiesData}
          handleTracking={handleTracking}
          logCancellationAndRescheduleDetails={logCancellationAndRescheduleDetails}
        />
      </S.FltDetailCnt>
    </S.FlightDetailsWrap>
  );
};

export default FlightInfo;
